import { Button } from "@chakra-ui/react";

const SubmitButton = ({ isLoading, text = "Save", loadingText = "Saving...", ...props }) => {
  return (
    <Button
      type="submit"
      className="button button--primary button--blue"
      colorScheme="blue"
      isLoading={isLoading}
      loadingText={loadingText}
      {...props} // Pass additional props like `className`, `onClick`, etc.
    >
      {text}
    </Button>
  );
};

export default SubmitButton;
